module.exports = __webpack_public_path__ + "img/terms-bg.710e218d.png";